export default __webpack_public_path__ + "static/media/bojo_s.da44499e.jpg";